import {
  SET_DIALOG_RECONNECTING_INFORMATION,
  SET_DIALOG_TRANSFER_CALL_RECEIVED,
  SET_DIALOG_PAUSE_ALERT,
  SET_DIALOG_AGENT_ABSENT,
} from '@/store/mutation-types';

const mutations = {
  [SET_DIALOG_RECONNECTING_INFORMATION](state, value) {
    state.dialogReconnectingInformation = value;
  },
  [SET_DIALOG_TRANSFER_CALL_RECEIVED](state, value) {
    state.dialogTransferCallReceived = value;
  },
  [SET_DIALOG_PAUSE_ALERT](state, value) {
    state.dialogPauseAlert = value;
  },
  [SET_DIALOG_AGENT_ABSENT](state, value) {
    state.dialogAgentAbsentDialog = value;
  },
};

export default mutations;
